import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChartBarConfig {
	horizontalBarThickness: number;
}

interface UiState {
	sidebarOpen: boolean;
	darkMode: boolean;
	loading: boolean;
	snackbar: {
		open: boolean;
		message: string;
		severity: 'success' | 'error' | 'warning' | 'info';
	};
	chartBarConfig: ChartBarConfig;
}

export const initialState: UiState = {
	sidebarOpen: true,
	darkMode: false,
	loading: false,
	snackbar: {
		open: false,
		message: '',
		severity: 'info',
	},
	chartBarConfig: {
		horizontalBarThickness: 34,
	},
};

const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		toggleSidebar: (state) => {
			state.sidebarOpen = !state.sidebarOpen;
		},
		setSidebarOpen: (state, action: PayloadAction<boolean>) => {
			state.sidebarOpen = action.payload;
		},
		toggleDarkMode: (state) => {
			state.darkMode = !state.darkMode;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		showSnackbar: (state, action: PayloadAction<{
			message: string;
			severity?: 'success' | 'error' | 'warning' | 'info';
		}>) => {
			state.snackbar = {
				open: true,
				message: action.payload.message,
				severity: action.payload.severity || 'info',
			};
		},
		hideSnackbar: (state) => {
			state.snackbar.open = false;
		},
		setHorizontalBarThickness: (state, action: PayloadAction<number>) => {
			state.chartBarConfig.horizontalBarThickness = action.payload;
		},
	},
});

export const {
	toggleSidebar,
	setSidebarOpen,
	toggleDarkMode,
	setLoading,
	showSnackbar,
	hideSnackbar,
	setHorizontalBarThickness,
} = uiSlice.actions;

export default uiSlice.reducer;